import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=unknown/none
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // Skip /me while Google OAuth callback is being processed
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) return { mfa_required: true, mfa_token: data.mfa_token };
    setUser(data.user);
    return data.user;
  };

  const verifyMfa = async (mfa_token, code) => {
    const { data } = await api.post("/auth/2fa/verify", { mfa_token, code });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, verifyMfa, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function homeForRole(role) {
  switch (role) {
    case "SUPER_ADMIN": return "/console/super";
    case "ADMIN": return "/console";
    case "DJ": return "/dj";
    case "ORGANIZER": return "/organizer";
    default: return "/dashboard";
  }
}
